import { usePaymentPoliciesApi } from '@pages/tutor'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const tutorId = to.params.id as string

  void usePaymentPoliciesApi({ tutorId })
})
